import { v4 as uuidv4 } from 'uuid';

export const HEADER_NAME = 'X-PB-Client-Context-Id';

const clientContextIdHeader = {
  [HEADER_NAME]: uuidv4(),
};

export const getClientContextIdHeader = () => ({
  ...clientContextIdHeader,
});

export const createClientContextIdHeaderFromValue = clientContextId => {
  clientContextIdHeader[HEADER_NAME] = clientContextId;

  return clientContextIdHeader;
};

export const regenerateClientContextIdHeader = () => {
  clientContextIdHeader[HEADER_NAME] = uuidv4();

  return clientContextIdHeader;
};
